import {FULLNAME_PATTERN} from './constants';
import assign from 'object-assign';
import {jqueryValidate} from '@modules/lazy-imports';
import $ from '@modules/jquery-import';
import {getSiteLocale, getCountryCode} from '@util/LocaleUtils';

jqueryValidate().then( () => {
    /**
     * Load localization plugins for jquery validate
     */

    const LOCALE = getSiteLocale();
    const COUNTRY_CODE = getCountryCode();
    const logRejectPlugin = err => console.warn( '[Deferred Plugin]', err );
    if ( LOCALE !== 'en-us' ) {
        import(/*webpackChunkName: "~~jquery-validate.messages"*/
        '@plugins/jquery-validate/localization/messages_' + LOCALE ).catch( logRejectPlugin );
        import(/*webpackChunkName: "~~jquery-validate.methods"*/
        '@plugins/jquery-validate/localization/methods_' + COUNTRY_CODE ).catch( logRejectPlugin );
    }

    // jQuery.validate extended defaults
    $.validator.defaults = assign(
        {},
        $.validator.defaults,
        {
            errorClass: 'field-validation-error',
            submitHandler: function ( form ) {
                this.currentElements.each( ( i, el ) => upi.forms.trimInput( el ) );
                form.submit();
            }
        }
    );

    /**
     * Provides email validation with trim method to avoid throwing errors if white space was
     * added to the field by user accidentally
     */
    $.validator.addMethod( 'email', function ( value, element ) {
        return this.optional( element ) ||
            /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
                value.trim() );
    } );

    /**
     * Provides loose validation for user first and last name in a single field
     */
    $.validator.addMethod( 'fullName', function ( value, element ) {
        return this.optional( element ) || FULLNAME_PATTERN.test( value );
    }, 'Please enter a valid First and Last name' );

    $.validator.addMethod( 'creditcard', function ( a, b ) {
        if ( this.optional( b ) ) {
            return 'dependency-mismatch';
        }
        if ( /[^0-9 \-]+/.test( a ) ) {
            return !1;
        }
        var c, d, e = 0, f = 0, g = !1;
        if ( a = a.replace( /\D/g, '' ), a.length < 13 || a.length > 19 ) {
            return !1;
        }
        for ( c = a.length - 1; c >= 0; c-- ) {
            d = a.charAt( c ), f = parseInt( d, 10 ), g && (f *= 2) > 9 &&
            (f -= 9), e += f, g = !g;
        }
        return e % 10 === 0;
    }, 'Please enter a valid credit card number' );
} );


